import { render } from "./FillingSquare.vue?vue&type=template&id=0bba6d96&scoped=true&ts=true"
import script from "./FillingSquare.vue?vue&type=script&lang=ts"
export * from "./FillingSquare.vue?vue&type=script&lang=ts"

import "./FillingSquare.vue?vue&type=style&index=0&id=0bba6d96&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bba6d96"]])

export default __exports__